<script lang="ts">
  import {
    digitalSourceTypeFaksimile,
    commonImageTypes,
    type Image,
    type CommonImageTypes as ImageType,
    type DigitalSourceType,
    digitalSourceTypeGrafikk,
    digitalSourceTypePhotography,
    digitalSourceTypeIllustrasjon,
    digitalSourceTypeKIGenerert,
  } from "bildebanken-model";
  import { updateField, type EditImageActor } from "./editImageMachine";
  import { mapDigitalSourceTypeToImageType, showAdvancedSourceTypeLabel } from "utils/fns";

  export let service: EditImageActor;
  export let imageTypeRequired: boolean;
  export let imageTypeRequiredMissingForCurrentImage: boolean;
  export let image: Image;

  let advancedImageType: Image["metadata"]["digitalSourceType"] | undefined;
  $: advancedImageType =
    image.metadata?.digitalSourceType &&
    !commonImageTypes.includes(image.metadata.digitalSourceType as ImageType)
      ? image.metadata.digitalSourceType
      : undefined;

  let touched = false;

  $: fieldMissing = imageTypeRequired && imageTypeRequiredMissingForCurrentImage && touched;

  function onDigitalSourceTypeChange(this: HTMLSelectElement) {
    touched = true;
    const value = this.value === "" ? undefined : (this.value as DigitalSourceType);

    if (value !== digitalSourceTypeFaksimile && image.metadata.source) {
      updateField(service, "source", "");
    }
    updateField(service, "digitalSourceType", value);
  }
  const SOURCE_TYPE_LABELS: Record<string, string> = {
    [digitalSourceTypeFaksimile]: "Faksimile",
    [digitalSourceTypeGrafikk]: "Grafikk",
    [digitalSourceTypePhotography]: "Fotografi",
    [digitalSourceTypeIllustrasjon]: "Illustrasjon",
    [digitalSourceTypeKIGenerert]: "KI-generert",
  };
</script>

<label style="margin-top: -0.25rem">
  Innholdstype
  <span class={imageTypeRequired ? "" : "hidden"}>*</span>
  <select
    class="org-input"
    value={image.metadata.digitalSourceType}
    on:change={onDigitalSourceTypeChange}
    data-testid="digital-source-type-select"
    aria-invalid={fieldMissing}
  >
    <option value=""></option>
    {#each commonImageTypes as imageType}
      <option value={imageType}>{SOURCE_TYPE_LABELS[imageType]}</option>
    {/each}
    {#if advancedImageType}
      <option value={advancedImageType} selected>
        {mapDigitalSourceTypeToImageType(advancedImageType)}
        {showAdvancedSourceTypeLabel(advancedImageType)}
      </option>
    {/if}
  </select>
  <span class="org-warning">Innholdstype må fylles ut</span>
</label>

<style>
  .hidden {
    display: none;
  }
  label {
    display: block;
    margin-bottom: var(--org-medium);
  }
</style>
